import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

/* ---------------------------------------
Forums
--------------------------------------- */

// Handle create forum
export const handleCreateForum = createAsyncThunk(
  "forum/create",
  async ({ data, isDraft }, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data: {
          ...data,
          isDraft, 
        },
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data",
        },
        url: `${BASEURI}/user/forum/create`,
      },
      thunkAPI
    )
  }
)


// Handle update forum
export const handleUpdateForum = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "POST",
        data: data?.formData,
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/user/forum/update/${data?.id}`,
      },
      thunkAPI
    )
  }
)

// Handle delete forum
export const handleDeleteForum = createAsyncThunk(
  "delete",
  async (id, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/user/forum/delete/${id}`,
      },
      thunkAPI
    )
  }
)

// Handle retrieve single forum
export const handleRetrieveForum = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/forum/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve all forums
export const handleRetrieveAllForums = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "Get",
        headers: headers(),
        url: `${BASEURI}/user/forum/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

/* ---------------------------------------
Comments 
--------------------------------------- */

// Handle retrieve commented forums (filter by user)
export const handleRetrieveCommentedForum = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/comment/forum/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve comments (filter by forum)
export const handleRetrieveForumComments = createAsyncThunk(
  "retrieveSingle",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/comment/forum/retrieve/${data?.id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

/* ---------------------------------------
Reaction 
--------------------------------------- */


// Handle retrieve all forums
export const handleReactedForums = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "Get",
        headers: headers(),
        url: `${BASEURI}/user/forum/reacted`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)